import 'css-chunk:src/app/containers/Home/CommunitiesView/ProgramsDetailView/ProgramOnboardingHTML.scss';export default {
  "ProgramOnboardingHTML": "_ProgramOnboardingHTML_17zdn_1"
};